import React from "react";
import {useQuery} from "@apollo/client";
import ListTable from "../../shared/ListTable";
import {tableImageTag} from "../../../helpers/Api";
import {getClientComments} from "../menus/MenuQueries";
import {Link} from "react-router-dom";
import Loader from "../../shared/Loader";

const ClientCommentsList = ({ client }) => {
  const { data, loading } = useQuery(getClientComments, { variables: { clientId: client.id } })

  const header = <tr>
    <th>Meniu</th>
    <th>Reteta</th>
    <th>Coment</th>
    <th>Data</th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>
        <Link to={`/menus/${item.menu.id}`}>
          {tableImageTag(item.menu)}
          {item.menu.name}
        </Link>
      </td>
      <td>
        <Link to={`/plates/${item.plate.id}`}>
          {tableImageTag(item.plate)}
          {item.plate.name}
        </Link>
      </td>
      <td>{item.comment}</td>
      <td>{item.createdAt}</td>
    </tr>
  }

  if (loading) return <Loader />;

  return (
    <div className="row justify-content-md-center">
      {/*<PageSubTitle title='Meniuri'/>*/}
      <div className=" justify-content-md-center">
        <div className="page-container col">
          <ListTable data={data && data.clientComments} header={header} listItem={listItem}
                     searchFields={['name', 'status']} />
        </div>
      </div>
    </div>
  )
};

export default ClientCommentsList;
